import React from 'react'
import { withTheme } from 'styled-components'
import { Tel, LocationIcon } from '@pga/pga-component-library'
import { Title, Text } from '../styled'
import {
  ContentWrapper,
  Wrapper,
  InfoWrapper,
  TextWrapper,
  Flag,
  Phone,
  facilityInfo
} from './shared'

const defaultStyle = (theme, viewConfig) => ({
  fontSize: viewConfig.infoFontSize,
  font: theme.fonts.Montserrat,
  weight: '500'
})

export const LocationInfo = ({ addressInfo, sectionName, theme, viewConfig }) => (
  <ContentWrapper viewConfig={viewConfig}>
    <Title pb='10px'>{viewConfig.title}</Title>
    <Wrapper flexDirection='column'>
      {
        addressInfo.name ? (
          <InfoWrapper>
            <Flag />
            <TextWrapper>
              {facilityInfo(addressInfo, theme).map(({ color, text, id, facilityId }) => (
                <Text key={id} {...defaultStyle(theme, viewConfig)} color={color}><a href={facilityId}>{text}</a></Text>
              ))}
            </TextWrapper>
          </InfoWrapper>
        ) : null
      }
      {
        addressInfo.phoneNumber ? (
          <InfoWrapper>
            <Phone />
            <Text {...defaultStyle(theme, viewConfig)}><Tel phoneNumber={addressInfo.phoneNumber} /></Text>
          </InfoWrapper>
        ) : null
      }
      {
        sectionName ? (
          <InfoWrapper>
            <LocationIcon className='locationIconPointerControl' />
            <Text {...defaultStyle(theme, viewConfig)}>Section: {sectionName}</Text>
          </InfoWrapper>
        ) : null
      }
    </Wrapper>
  </ContentWrapper>
)

export default withTheme(LocationInfo)
